import React, { useEffect, useState } from 'react';
import { Fragment } from 'react';
import Loader from '../../loader/Loader';
import Footer from '../Footer/Footer';
import Trial from '../Home/Trial';
import Testimonial from '../Home/Testimonial';
import Price from './Price';
import PriceBenefits from './PriceBenefits';
import CreditExplainer from './CreditExplainer';
import FeatureComparison from './FeatureComparison';
import PricingFAQ from './PricingFAQ';
import PageSEO from '../Common/PageSEO';
import { useLocale } from '../../localization/LocaleContext';

function  PriceMain() {
    const { t, locale } = useLocale();

   const[loader, SetLoader] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => {
            SetLoader(true)
        }, 1500)

        return () => clearTimeout(timer)
    }, [])

    if (!loader) {
        return <Loader/>;
    }
    return(
        <Fragment>
            <PageSEO title={t('meta.pricingTitle')} description={t('meta.pricingDescription')} path="/pricing" locale={locale} />
            <Price/>
            <FeatureComparison/>
            <CreditExplainer/>
            <PriceBenefits/>
            <Testimonial/>
            <PricingFAQ/>
            <Trial/>
            <Footer/>
        </Fragment>
    )
}

export default PriceMain;